import { FormPreviewComponent } from "./designComponent/FormPreviewComponent";
import React from "react";
import { ProgramContainer } from "./entities/formTemplateDataType";
import { User } from "./entities/User";
import { RuntimeHeaderComponent } from "./commonComponent/RuntimeHeaderComponent";
import { RuntimeFooterComponent } from "./commonComponent/RuntimeFooterComponent";
import ReactGA from 'react-ga4';
import { ServiceOntarioHeaderComponent } from "./commonComponent/ServiceOntarioHeaderComponent";
import TimeoutComponent from "./TimeoutComponent";
import { SessionEndComponent } from "./SessionEndComponent";
import DataUtils from "./utilities/DataUtils";
import { gaPageview } from "./utilities/GAUtils";
import { ApplicationHeaderComponent } from "./commonComponent/ApplicationHeaderComponent";
import { getCxpMessages, getCxpProfile, getUserProfileFromSession } from "./services/CxpProfileService";
import HelmetComponent from "./commonComponent/HelmetComponent";
import DynamicScriptContent from "./commonComponent/DynamicScriptComponent";
import { MaintainableApps, ManitenaceReason, Scripts, TOKEN_TYPE } from "./entities/Constants";
import { cleanSession, fetchSessionFromServer } from "./security/PublicSecure";
import { is } from "date-fns/locale";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./security/msalInstance";
import SessionStorageService from "./services/SessionStorageService";
import URLUtils, { getAppNameFromPath } from "./utilities/URLUtils";
import axios from "axios";
import Maintenance from "./commonComponent/MantenanceComponent";
import CMAUtils from "./utilities/CMAUtils";
import * as CircularJSON from 'circular-json';
import { getAdminConfig } from "./services/EnvConfigService";
import { Toast } from 'primereact/toast';
interface Props {
    programContainer: ProgramContainer;
}

interface State {
    programContainer: ProgramContainer
    isEng: boolean,
    showModal: boolean,
    showSessionEndPage: boolean
}


export class RuntimeComponent extends React.Component<Props, State> {
    idleTimeout;
    idleDuration: number;
    growl: Toast;
    // idleSessionDuration: number;
    events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

    constructor(props) {
        super(props);

        let isEng = this.props.programContainer.Profile?.lang !== 'fr';

        const url = window.location.href;

        if (url.indexOf("/fr") > 0) {
            isEng = false;
        }

        this.state = {
            isEng: this.props.programContainer.EnglishOnly || isEng,
            programContainer: this.props.programContainer,
            showModal: false,
            showSessionEndPage: false
        }

        this.idleTimeout = null;

        this.idleDuration = Number(process.env.SESSION_DURATION) * 60 * 1000; //set up in minute in config file
        if (this.props.programContainer.GATrackingID) {
            ReactGA.initialize(this.props.programContainer.GATrackingID);
        }

    }

    componentWillUnmount() {
        if (this.idleTimeout) clearTimeout(this.idleTimeout);
    }

    resetTimer = () => {
        if (this.idleTimeout) clearTimeout(this.idleTimeout);
        this.setState({ showModal: false });
        this.idleTimeout = setTimeout(() => this.setState({ showModal: true }), this.idleDuration);
    }


    handleEvent = () => {
        this.resetTimer();
    }

    handleClose = () => {
        this.setState({ showModal: false });
        this.resetTimer();
    }

    modalTimeout = () => {
        this.setState({ showModal: false, showSessionEndPage: true });
        cleanSession(this.props.programContainer.CategoryId, this.props.programContainer.Profile, this.state.isEng ? 'en' : 'fr');
    }

    handleCancel = () => {
        if (this.state.programContainer.Profile) {
            cleanSession(this.props.programContainer.CategoryId, this.props.programContainer.Profile, this.state.isEng ? 'en' : 'fr');
            // window.location.replace(this.state.isEng ? process.env.CXP_URL : process.env.CXP_URL_F);
        } else {
            window.location.replace(this.state.isEng ? process.env.SERVICEONTARIO_URL : process.env.SERVICEONTARIO_URL_F);
        }
    }

    async componentDidMount() {
        this.resetTimer();
        // this.resetSessionTimer();

        //this.events.forEach(event => window.addEventListener(event, this.handleEvent));
        window.addEventListener('storage', (event: any) => {
            if (event.key === 'userProfile') {
                console.log(event.newValue)
                if (event.newValue) {
                    console.log(`localStorage new item added: ${event.key}`);
                    //this.props.programContainer.Profile = JSON.parse(event.newValue);
                } else if (this.props.programContainer.Profile) {
                    console.log(`localStorage cleared: ${event.key}`);
                    //this.props.programContainer.Profile = null;
                }
            }
        });
        window.addEventListener('mousemove', (event) => {
            event.preventDefault();
        })

        let isEng = this.state.isEng ?? true;

        let refreshProfile = false;
        if (!this.props.programContainer.Profile?.firstName && !this.props.programContainer.Profile?.lastName) {
            const userProfile = getUserProfileFromSession(); // localStorage.getItem('userProfile'); // || sessionStorage.getItem('chcInfo');
            isEng = userProfile?.lang !== 'fr'
            this.props.programContainer.Profile = userProfile;
            console.log('get usr profile in runtime:', userProfile);
            if (userProfile?.userId && !userProfile?.token) {
                const programContainer = await fetchSessionFromServer(this.props.programContainer);
                this.props.programContainer.Profile = programContainer.Profile;
            }
            if (this.props.programContainer.Profile?.token) {
                const messages = await getCxpMessages(
                    this.props.programContainer.Profile.token,
                    { pageNumber: 1, pageSize: 5, search: '' }
                );
                this.props.programContainer.Profile.messages = messages.messages;
            }

            if (MaintainableApps.includes(this.props.programContainer.CategoryId.toLowerCase())) {
                const adminConfig = await getAdminConfig(this.props.programContainer.CategoryId);
                this.props.programContainer.adminConfig = adminConfig;
            }
            this.setState({ programContainer: this.props.programContainer });
        }
        const url = window.location.href;

        if (url.indexOf("/fr") > 0) {
            isEng = false;
        }

        if (isEng !== this.state.isEng) {
            this.setState({ isEng: isEng });
        }



        gaPageview({
            page: url + window.location.search,
            title: isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA,
        }, this.props.programContainer.GATrackingID);
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        window.addEventListener('mousemove', (event) => {
            event.preventDefault();
        });

        if (this.props.programContainer.Profile !== prevProps.programContainer.Profile) {
            this.setState({
                programContainer: this.props.programContainer
            });
        }
    }

    htmlString = () => {

        let htmlString = [];
        if (process.env.DYNAMIC_SCRIPT_ENABLED === 'true' && process.env.DYNAMIC_SCRIPT_NAME) {
            htmlString.push(<DynamicScriptContent scripts={Scripts[process.env.DYNAMIC_SCRIPT_NAME]} />)
        }


        if (this.state.showModal && this.props.programContainer.TimeoutPopup)
            htmlString.push(
                <TimeoutComponent
                    onClose={this.handleClose}
                    onCancel={this.handleCancel}
                    onTimeup={this.modalTimeout} isEng={this.state.isEng}
                />
            )


        if (this.props.programContainer.HeaderType == "Ontario") {
            if (this.props.programContainer.AuthRequired == 'ad') {
                if (this.state.isEng == undefined) this.setState({ isEng: true });
                htmlString.push(
                    <MsalProvider instance={msalInstance}>
                        <RuntimeHeaderComponent
                            // programContainer={this.props.programContainer} 
                            programContainer={this.state.programContainer}
                            isEng={this.state.isEng}
                            headerConfig={this.state.programContainer.HeaderConfig}
                            comments={this.state.programContainer.Entity?.comments ?? []}
                            profile={this.props.programContainer.Profile}
                            callback={(isEng) => {
                                document.documentElement.lang = isEng ? 'en' : "fr";
                                this.setState({ isEng: isEng })
                            }}
                            callbackState={(programContainer) => { this.setState({ programContainer: programContainer }) }}
                            callbackLogin={() => {            
                               let token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
                                if (token && process.env.IS_RUNTIME!=='deployed') {
                                    const categoryId = getAppNameFromPath();
                                    const url = "data/case/get/" + categoryId;
                                    const urlFull = URLUtils.concatUrls(url);
                                    const headers = {
                                        'Authorization': `Bearer ${token}`
                                    }

                                    axios.get(urlFull, { headers: headers }).then(
                                        (response) => {
                                            let parsedProgramContainer = CircularJSON.parse(response.data.attachment) as ProgramContainer;
                                            this.setState({ programContainer: parsedProgramContainer });
                                            sessionStorage.removeItem("preAuthUrl");
                                        }
                                    )

                                }

                                let profile = {
                                    Email: SessionStorageService.getUserId()
                                }
                                this.props.programContainer.Profile = profile;
                            }}
                        />
                    </MsalProvider>
                )
            } else {
                <RuntimeHeaderComponent programContainer={this.props.programContainer} isEng={this.state.isEng}
                    callback={(isEng) => {
                        document.documentElement.lang = isEng ? 'en' : "fr";
                        this.setState({ isEng: isEng })
                    }}
                    callbackCMASaved={() => this.displayToast()}
                />
            }
        }

        htmlString.push(<>
            <div style={{ display: this.props.programContainer.HeaderType == "ServiceOntario" ? 'block' : 'none' }}>
                <ServiceOntarioHeaderComponent programContainer={this.props.programContainer} isEng={this.state.isEng ?? true}
                    profile={this.props.programContainer.Profile}
                    callbackProgramContainer={(programContainer) => { this.setState({ programContainer: programContainer }) }}
                    callback={(isEng) => {
                        this.setState({ isEng: isEng })
                    }}
                />
            </div>

            <div style={{ display: this.props.programContainer.HeaderType == "Application" ? 'block' : 'none' }}>
                <ApplicationHeaderComponent programContainer={this.props.programContainer} isEng={this.state.isEng ?? true}
                    callback={(isEng) => {
                        this.setState({ isEng: isEng })
                    }}></ApplicationHeaderComponent>
            </div>

            <div style={{ display: this.state.showSessionEndPage ? "block" : "none", maxWidth: '72rem', margin: 'auto', padding: '0 1rem' }} >
                <SessionEndComponent isEng={this.state.isEng} programContainer={this.props.programContainer} />
            </div>
            <main id="main-content">
                {/* <HelmetComponent title='dynamic title' /> */}
                <div style={{ display: this.state.showSessionEndPage ? "none" : "block", maxWidth: '72rem', margin: 'auto', padding: '0 1rem' }} >
                    <FormPreviewComponent
                        programContainer={this.state.programContainer}
                        isEng={(this.state.isEng ?? true) || this.props.programContainer.EnglishOnly}
                        callBackLang={isEng => this.setState({ isEng: isEng })}
                        callback={(programContainer) => { this.setState({ programContainer: programContainer }) }}
                        callbackOriginalData={(originalData) => { console.log(originalData) }} />
                </div>
            </main>
            <footer>
                <RuntimeFooterComponent isEng={this.state.isEng || this.props.programContainer.EnglishOnly} ></RuntimeFooterComponent>
            </footer>
        </>)
        htmlString.push(
            <>
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
            </>
        )
        return htmlString;
    }
    displayToast = () => {
        this.growl.show({ severity: 'success', summary: 'saved', detail: 'Data saved' });
    }
    render() {
        if (this.props.programContainer == null) return null;

        if (this.state.showModal) {
            this.events.forEach(event => window.removeEventListener(event, this.handleEvent));
            if (this.idleTimeout) clearTimeout(this.idleTimeout);
        }
        if (this.state.programContainer?.adminConfig?.isActive) {
            return (
                <main id="main-content">
                    <div style={{ display: 'block', maxWidth: '72rem', margin: 'auto', padding: '0px 1rem' }}>
                        <Maintenance adminConfig={this.props.programContainer.adminConfig}
                            app={this.state.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA}
                            lang={this.state.isEng ? 'en' : 'fr'}
                        />
                    </div>
                </main>
            );
        }


        return this.htmlString();
    }
}